import { WithRef } from '../../../types';
import IconBase, {
  RenderFunction,
  IconWeight,
  IconProps,
  PaintFunction,
  renderPathForWeight,
} from '../IconBase';

const pathsByWeight = new Map<IconWeight, PaintFunction>();

pathsByWeight.set('regular', (color: string) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 20H20V24H24V20Z" fill={color} />
    <path
      d="M14 6H6V14H14V6Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 6H18V14H26V6Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 18H6V26H14V18Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 20H20V24H24V20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

pathsByWeight.set('light', (color: string) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 20H20V24H24V20Z" fill={color} />
    <path
      d="M14 6H6V14H14V6Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 6H18V14H26V6Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 18H6V26H14V18Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 20H20V24H24V20Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

pathsByWeight.set('fill', (color: string) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M24 20H20V24H24V20Z" fill={color} />
    <path
      d="M14 6H6V14H14V6Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 6H18V14H26V6Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 18H6V26H14V18Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24 20H20V24H24V20Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

const renderPath: RenderFunction = (weight: IconWeight, color: string) =>
  renderPathForWeight(weight, color, pathsByWeight);

export const CastRebalancer = ({
  ref,
  ...props
}: WithRef<SVGSVGElement, IconProps>) => (
  <IconBase ref={ref} {...props} renderPath={renderPath} />
);

CastRebalancer.displayName = 'CastRebalancer';
